import React from 'react'
import { Link, Redirect } from 'react-router-dom'
import { capitalize } from 'lodash'
import { Card, CardActions, CardTitle, CardText } from 'material-ui-legacy/Card'
import Paper from 'material-ui-legacy/Paper'

import { getWindowHeight } from '../../lib/util.js'
import { formatDate } from '../../lib/formats'
import DeleteButton from '../UI/DeleteButton'
import EditButton from '../UI/EditButton'
import InfoLinkButton from '../UI/InfoLinkButton'
import CloseButton from '../UI/CloseButton'
import ErrorDialog from '../UI/ErrorDialog'
import PlainText from '../UI/PlainText'
import QuotesPager from '../Quotes/QuotesPager'

class ProjectCard extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      error: '',
      redirect: ''
    }

    // Data can be received either as project or itemData.
    this.project = this.props.project || this.props.itemData
  }

  _closeErrorDialog = () => this.setState({ error: '' })

  _redirect = url => this.setState({ redirect: url })

  render() {
    const { editCallback, deleteCallback, closeCallback } = this.props

    const { redirect, error } = this.state

    if (redirect) return <Redirect push to={redirect} />

    const project = this.project
    const attributes = project.attributes
    const client = project.included('client')
    const agency = project.included('agency')
    const agencyProducer = project.included('agencyProducer')
    const user = project.included('user')
    const cardStyle = {
      overflowY: 'auto',
      minHeight: '300px',
      maxHeight: `${getWindowHeight() - 210}px`
    }
    const paperStyle = {
      width: '99%',
      padding: '10px',
      overflow: 'auto',
      marginTop: '5px'
    }

    return (
      <Card style={cardStyle}>
        <CardTitle
          title={`${attributes.name} (Docket #${project.attributes.formattedDocketNo})`}
          subtitle={capitalize(attributes.state)}
        />

        <CardText>
          <p>
            <strong>Project type:</strong> {attributes.projectTypeName}
          </p>

          <p>
            <strong>Campaign:</strong> {attributes.campaign}
          </p>

          <p>
            <strong>Product:</strong> {attributes.product}
          </p>

          <p>
            <strong>Client:</strong>&nbsp;
            <Link to={`/clients/${attributes.clientId}`}>
              {client.attributes.name}
            </Link>
          </p>

          <p>
            <strong>Agency:</strong>&nbsp;
            <Link to={`/agencies/${attributes.agencyId}`}>
              {agency.attributes.name}
            </Link>
          </p>

          {attributes.agencyProducerId && (
            <p>
              <strong>External project manager:</strong>&nbsp;
              <Link to={`/agency-producers/${attributes.agencyProducerId}`}>
                {agencyProducer.attributes.fullName}
              </Link>
            </p>
          )}
          <p>
            <strong>Internal producer:</strong> {user.attributes.fullName}
          </p>

          <p>
            <strong>Date:</strong> {formatDate(attributes.date)}
          </p>

          <p>
            <strong>Last updated:</strong> {formatDate(attributes.updatedAt)}
          </p>

          {attributes.jobDescription && (
            <p>
              <strong>Job description:</strong>
              <Paper style={paperStyle}>
                <PlainText text={attributes.jobDescription} wrapText={100} />
              </Paper>
            </p>
          )}

          {attributes.description && (
            <p>
              <strong>Requisition (internal):</strong>
              <Paper style={paperStyle}>
                <PlainText text={attributes.description} wrapText={100} />
              </Paper>
            </p>
          )}

          <QuotesPager projectId={project.id} />
        </CardText>

        <CardActions>
          <InfoLinkButton url={`/projects/${project.id}`} />
          {editCallback && <EditButton onTouchTap={editCallback} />}
          {deleteCallback && (
            <DeleteButton
              onTouchTap={deleteCallback}
              confirmMessage={
                <p>
                  Are you sure you want to delete{' '}
                  <strong>{project.attributes.name}</strong>? There's no undo.
                </p>
              }
            />
          )}
          {closeCallback && <CloseButton onTouchTap={closeCallback} />}
        </CardActions>

        <ErrorDialog
          open={Boolean(error)}
          closeCallback={this._closeErrorDialog}
        >
          <p>
            <strong>Error:</strong> {error}
          </p>
        </ErrorDialog>
      </Card>
    )
  }
}

export default ProjectCard



// WEBPACK FOOTER //
// ./src/components/Projects/ProjectCard.jsx